export default __webpack_public_path__ + "static/media/dark-logo.b417ef41.png";